import createLazyComponent from '../LazyComponent';

const LegalAgreement = createLazyComponent(() => import('./LegalAgreementPage'));

export default LegalAgreement;
